import { render } from "./blog-category-delete.vue?vue&type=template&id=2a90e46a"
import script from "./blog-category-delete.vue?vue&type=script&lang=js"
export * from "./blog-category-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__